// NotificationBell.jsx - ИСПРАВЛЕННАЯ ВЕРСИЯ
import React, { useState, useRef, useEffect } from 'react';
import { 
  Badge, 
  Dropdown, 
  ListGroup, 
  Button, 
  Spinner
} from 'react-bootstrap';
import { useNotifications } from '../contexts/NotificationContext';
import { useNavigate } from 'react-router-dom';

const NotificationBell = ({ isMobile = false }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  
  const { 
    notifications, 
    unreadCount, 
    loading, 
    markAsRead,
    markAllAsRead,
    loadNotifications,
    isWsConnected,
    wsState
  } = useNotifications();

  // Закрытие dropdown при клике вне его области
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleBellClick = () => {
    setShowDropdown(!showDropdown);
    if (!showDropdown) {
      loadNotifications({ limit: 10 });
    }
  };

  const handleNotificationClick = async (notification) => {
    if (notification.status === 'unread') {
      await markAsRead(notification.id);
    }
    setShowDropdown(false);
    
    // Переход по ссылке из уведомления если есть
    if (notification.data?.link) {
      navigate(notification.data.link);
    }
  };

  const handleMarkAllAsRead = async () => {
    await markAllAsRead();
    setShowDropdown(false);
  };

  const handleViewAll = () => {
    setShowDropdown(false);
    navigate('/_admin/notifications');
  };

  const formatTime = (dateString) => {
    if (!dateString) return 'только что';
    
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'только что';
    if (diffMins < 60) return `${diffMins} мин назад`;
    if (diffHours < 24) return `${diffHours} ч назад`;
    if (diffDays < 7) return `${diffDays} дн назад`;
    
    return date.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'short'
    });
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'success': return 'bi-check-circle-fill text-success';
      case 'warning': return 'bi-exclamation-triangle-fill text-warning';
      case 'error': return 'bi-x-circle-fill text-danger';
      case 'system': return 'bi-gear-fill text-primary';
      default: return 'bi-info-circle-fill text-info';
    }
  };

  const getWsStateTitle = () => {
    switch (wsState) {
      case 'connected': return 'WebSocket подключен';
      case 'connecting': return 'WebSocket подключение...';
      case 'disconnected': return 'WebSocket отключен';
      default: return 'Неизвестный статус';
    }
  };

  const getWsStateColor = () => {
    switch (wsState) {
      case 'connected': return 'bg-success';
      case 'connecting': return 'bg-warning';
      case 'disconnected': return 'bg-danger';
      default: return 'bg-secondary';
    }
  };

  const latestNotifications = notifications.slice(0, 5);

  return (
    <div className="position-relative notification-dropdown" ref={dropdownRef}>
      {/* Кнопка колокольчика */}
      <button
        type="button"
        className="notification-bell-btn position-relative d-flex align-items-center justify-content-center"
        onClick={handleBellClick}
        aria-label="Уведомления"
        aria-expanded={showDropdown}
      >
        {/* Меняем иконку в зависимости от наличия непрочитанных */}
        <i className={`bi ${unreadCount > 0 ? 'bi-bell-fill text-primary' : 'bi-bell'} notification-bell-icon`}></i>
        
        {/* Бейдж с количеством непрочитанных */}
        {unreadCount > 0 && (
          <Badge 
            bg="danger" 
            className="position-absolute notification-badge"
          >
            {unreadCount > 99 ? '99+' : unreadCount}
          </Badge>
        )}
      </button>

      {/* Dropdown с уведомлениями */}
      <Dropdown show={showDropdown} className="position-absolute" style={{ 
        top: '100%', 
        [isMobile ? 'right' : 'right']: '0', 
        zIndex: 1060 
      }}>
        <Dropdown.Menu 
          show 
          className="shadow border-0 mt-2"
          style={{ 
            width: isMobile ? '95vw' : '400px',
            maxWidth: isMobile ? '400px' : '95vw',
            maxHeight: isMobile ? '70vh' : '75vh',
            overflow: 'hidden',
            [isMobile ? 'right' : 'right']: isMobile ? '10px' : '0',
            left: isMobile ? 'auto' : 'auto'
          }}
        >
          {/* Заголовок */}
          <div className="d-flex justify-content-between align-items-center p-4 border-bottom bg-light">

            <div className="d-flex align-items-center gap-3">
                          {isWsConnected && (
                <div className="">
                  <span className={`ws-indicator ${wsState}`}></span>
                  {/* <small className="text-muted">{getWsStateTitle()}</small> */}
                </div>
              )}
              <div>
                <h6 className="mb-0 fw-bold">Уведомления</h6>
                <small className="text-muted">
                  {unreadCount > 0 
                    ? `${unreadCount} непрочитанных` 
                    : 'Все уведомления прочитаны'
                  }
                </small>
              </div>
              
            </div>
            <div className="d-flex gap-2">
              {unreadCount > 0 && (
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  onClick={handleMarkAllAsRead}
                  title="Отметить все как прочитанные"
                  className="rounded-circle d-flex align-items-center justify-content-center"
                  style={{ width: '32px', height: '32px' }}
                >
                  <i className="bi bi-check-all"></i>
                </Button>
              )}
              <Button 
                variant="outline-primary" 
                size="sm"
                onClick={handleViewAll}
                title="Все уведомления"
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: '32px', height: '32px' }}
              >
                <i className="bi bi-list"></i>
              </Button>
            </div>
          </div>

          {/* Список уведомлений */}
          <div style={{ maxHeight: isMobile ? '60vh' : '400px', overflowY: 'auto' }}>
            {loading ? (
              <div className="text-center p-5">
                <Spinner animation="border" variant="primary" />
                <div className="mt-3 text-muted">Загрузка уведомлений...</div>
              </div>
            ) : latestNotifications.length === 0 ? (
              <div className="text-center p-5 text-muted">
                <i className="bi bi-bell-slash display-4 mb-3 opacity-50"></i>
                <div className="fw-medium">Нет уведомлений</div>
                <small>Здесь появятся ваши уведомления</small>
              </div>
            ) : (
              <ListGroup variant="flush">
                {latestNotifications.map(notification => (
                  <ListGroup.Item
                    key={notification.id}
                    className={`border-0 p-0 notification-item ${notification.status === 'unread' ? 'notification-item-unread' : 'notification-item-read'}`}
                    onClick={() => handleNotificationClick(notification)}
                    style={{ cursor: 'pointer' }}
                  >
                    <div className="p-4">
                      <div className="d-flex gap-3">
                        <div className="flex-shrink-0 mt-1">
                          <i className={`bi ${getNotificationIcon(notification.notification_type)} fs-5`}></i>
                        </div>
                        <div className="flex-grow-1">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <h6 className="mb-0 fw-semibold" style={{ fontSize: '0.95rem' }}>
                              {notification.title}
                            </h6>
                            <small className="text-muted">
                              {formatTime(notification.created_at)}
                            </small>
                          </div>
                          <p 
                            className="mb-2 text-muted" 
                            style={{ 
                              fontSize: '0.85rem',
                              lineHeight: '1.4'
                            }}
                          >
                            {notification.message}
                          </p>
                          {notification.status === 'unread' && (
                            <Badge bg="primary" className="fs-7 px-2 py-1">
                              новое
                            </Badge>
                          )}
                        </div>
                      </div>
                    </div>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </div>

          {/* Футер */}
          <div className="p-3 border-top bg-light">
            <Button 
              variant="outline-primary" 
              size="sm" 
              className="w-100 d-flex align-items-center justify-content-center gap-2"
              onClick={handleViewAll}
            >
              <span>Все уведомления</span>
              <i className="bi bi-arrow-right"></i>
            </Button>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default NotificationBell;